<template>
    <div class="d-flex flex-column wrapper">
        <div class="d-flex px-4">
            <span>{{ text }}</span>
            <v-btn
                @click="ButtonClickFunction"
                text
                color="#0fff95"
            >
                    ATUALIZAR
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        ButtonClickFunction: Function,
    },
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>


span {
    color: white;
    font-size: 1rem;
}
</style>
